// extracted by mini-css-extract-plugin
export var button = "_dc-4";
export var hasDarkBackground = "_dc-7";
export var hasLightBackground = "_dc-6";
export var iconWrapper = "_dc-0";
export var large = "_dc-2";
export var medium = "_dc-1";
export var small = "_dc-5";
export var xsmall = "_dc-3";